import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useMedia } from "../contexts/MediaContext";

const Breadcrumbs = ({ breadcrumbs, onResizeStart, newsTitle }) => {
  // デバイス判定
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  // MediaContextから安全にisMediaOpenを取得
  let isMediaOpen = false;
  try {
    const mediaContext = useMedia();
    isMediaOpen = mediaContext?.isMediaOpen || false;
  } catch (error) {
    // MediaProviderが存在しない場合（LessonEditPage等）はfalseとして扱う
  }

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // 動的なbreadcrumbsを生成
  const dynamicBreadcrumbs = React.useMemo(() => {
    const result = [...breadcrumbs];

    // Newsページの場合は詳細パスを追加
    if (
      location.pathname.startsWith("/news/") &&
      location.pathname !== "/news"
    ) {
      const pathSegments = location.pathname.split("/");
      const newsId = pathSegments[2];

      if (newsId === "new") {
        result.push({ title: "新規記事", path: location.pathname });
      } else if (newsTitle) {
        result.push({ title: newsTitle, path: location.pathname });
      } else {
        result.push({ title: `記事: ${newsId}`, path: location.pathname });
      }
    }

    return result;
  }, [breadcrumbs, location.pathname, newsTitle]);

  return (
    <ul className="break">
      {dynamicBreadcrumbs.map((breadcrumb, i) => {
        return (
          <li key={i}>
            <Link to={breadcrumb.path}>{breadcrumb.title}</Link>
          </li>
        );
      })}
      <li className="resize-handle-breadcrumb">
        {onResizeStart && !isMobile && !isMediaOpen && (
          <div
            className="resize-icon"
            onMouseDown={(e) => onResizeStart(e, "horizontal")}
            style={{
              cursor: "ew-resize",
              padding: "8px 12px",
              fontSize: "20px",
              color: "#ffffff",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "40px",
              height: "32px",
              borderRadius: "6px",
              transition: "all 0.2s",
              border: "1px solid transparent",
            }}
            title="編集エリアの幅を調整"
          >
            <i className="fa-thin fa-arrows-up-down"></i>
          </div>
        )}
      </li>
    </ul>
  );
};

export default React.memo(Breadcrumbs);
